import React from 'react';
import FeatureTab from './FeatureTab';
import featureNames from '@utils/featureToggle/constants';
import TemporaryDashboardTabs from './TemporaryDashboardTabs';

const Eco2Tabs = ({ activeId }) => {
  return (
    <>
      <FeatureTab
        tabKey="experience-alerts"
        isGA={false}
        feature={featureNames.ECO_SERVER_ENABLED}
        tabTitle="Experience Alerts"
        route="/dashboard/ai-alerts"
        exact
      />
      <TemporaryDashboardTabs renderSharedTab={() => {}} activeId={`${activeId}`} />
    </>
  );
};

export default Eco2Tabs;
